// extracted by mini-css-extract-plugin
export default {"h":"style_h__Cw4gB","h2":"style_h2__TGC-h","p2":"style_p2__KNugM","h3":"style_h3__et4xD"};